import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import YM from 'utils/metrics';
import { validateValue, VALIDATION_TYPES } from 'utils/validation';
import Button from 'components/Button';
import InputPrefix from 'components/Input/InputPrefix';
import Modal from '../';
import classes from './modalSubclientLogin.module.scss';
import { IModalSubclientLogin } from './types';

const ModalSubclientLogin: React.FC<IModalSubclientLogin> = ({
	className,
	isOpen,
	onSubmit,
	onClose,
	title,
	text,
	submitButtonText = 'Создать',
	cancelButtonText = 'Отмена',
	error: externalError,
}) => {
	const [login, setLogin] = useState('');
	const [error, setError] = useState(externalError);
	const [isLoading, setIsLoading] = useState(false);

	const resetFormData = () => {
		setLogin('');
		setError('');
	};

	useEffect(() => {
		if (!isOpen) {
			resetFormData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	useEffect(() => {
		if (externalError) {
			setError(externalError || '');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [externalError]);

	const validateLogin = (value: string): boolean => {
		const newError = validateValue({
			type: VALIDATION_TYPES.LOGIN,
			value,
			isRequired: true,
		});
		setError(newError);
		const isValid = !newError;
		return isValid;
	};

	const handleChangeEmail = (value: string): void => {
		setLogin(value);
		validateLogin(value);
	};

	const handleSubmit = async (
		e: React.FormEvent<HTMLFormElement>
	): Promise<void> => {
		e.preventDefault();
		if (isLoading) return;

		const isValid = validateLogin(login);
		if (!isValid) return;

		setIsLoading(true);
		try {
			await onSubmit(`RTK-${login}`);
			YM.onFormSubmit();
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	};

	const form = (
		<form className={classes.form} onSubmit={handleSubmit}>
			<InputPrefix
				className={classes.login}
				value={login}
				onChange={handleChangeEmail}
				prefix="RTK-"
				placeholder="RTK-логин"
				error={error}
			/>
			<div className={classes.buttons}>
				<Button
					className={classes.buttonSubmit}
					text={submitButtonText}
					type="submit"
					isLoading={isLoading}
				/>
				<Button
					className={classes.buttonCancel}
					text={cancelButtonText}
					styleType="secondary"
					onClick={onClose}
				/>
			</div>
		</form>
	);

	return (
		<Modal
			className={cn(classes.modalSubclientLogin, className)}
			isOpen={isOpen}
			onClose={onClose}
		>
			{title && <div className={classes.title}>{title}</div>}
			{text && <div className={classes.text}>{text}</div>}
			{form}
		</Modal>
	);
};

export default ModalSubclientLogin;
